import { useRef, useEffect } from "react";
import "./style.scss";
import videoAsset from "./video/video.mp4";
// import posterImage from "./images/video-poster.jpg";

export default function BubbleVideo() {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    const playVideo = () => {
      if (video) {
        video.play().catch(() => {
          console.log("Autoplay prevented");
        });
      }
    };

    if (video) {
      if (video.readyState >= 3) {
        playVideo();
      } else {
        video.addEventListener("loadeddata", playVideo);
      }
    }

    return () => {
      if (video) {
        video.removeEventListener("loadeddata", playVideo);
      }
    };
  }, []);

  return (
    <div className="bubble-video-component-wrapper">
      <div className="bubble-video-component">
        <div className="bubble-video-fx">
          <video
            ref={videoRef}
            className="bubble-video"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
          >
            <source src={videoAsset} type="video/mp4" />
          </video>

          <div className="bubble-video-tint" aria-hidden />
        </div>
      </div>
    </div>
  );
}
